module.exports = __webpack_public_path__ + "static/media/uv-sc.c33463bf.svg";